import { AppMap, CurrentLocation } from '@ro-atoms/RoTooltip/RoTooltip.types';
import Overlay, { Options } from 'ol/Overlay';

export const setRoTooltip = (currentLocation: CurrentLocation, tooltip: Overlay | false, map: AppMap) => {
  if (!tooltip) {
    tooltip = new Overlay({
      element: document.getElementById('RoTooltip')
    } as Options);
    map.addOverlay(tooltip);
  }
  //@ts-ignore
  tooltip && tooltip.setPosition(currentLocation.transformed);
};
